import { statusLabel } from "@/lib/staff/format";
import type { RoomStatus } from "@/lib/staff/types";
import styles from "./StatusBadge.module.scss";

const STATUS_CLASS: Record<RoomStatus, string> = {
  UPCOMING: styles.upcoming,
  ACTIVE: styles.active,
  COMPLETED: styles.completed,
  CANCELLED: styles.cancelled,
};

interface Props {
  status: RoomStatus;
}

export function StatusBadge({ status }: Props) {
  return (
    <span className={`${styles.root} ${STATUS_CLASS[status]}`}>
      <span className={styles.dot} />
      {statusLabel(status)}
    </span>
  );
}
